import { render, staticRenderFns } from "./WoClosureNotes.vue?vue&type=template&id=17598ce5&"
import script from "./WoClosureNotes.vue?vue&type=script&lang=js&"
export * from "./WoClosureNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports